import { DynamicObjectInterface } from '../type';
import { AxiosUtilsType, axiosGet, axiosPost, axiosPut, axiosPatch } from './axiosUtils';
import './axiosInterceptor';

const CampaignService = {
  async addCampaign(campaign: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`campaign/create`, campaign);
  },

  async getCampaigns(): AxiosUtilsType {
    return await axiosGet(`campaign/list`);
  },
  async getAllCampaigns(): AxiosUtilsType {
    return await axiosGet(`campaign/list?filter=ALL`);
  },

  async getCampaignDetail(recId: string): AxiosUtilsType {
    return await axiosGet(`campaign/list/${recId}`);
  },

  async getCampaignDetailByCampaignId(campaignId: string): AxiosUtilsType {
    return await axiosGet(`campaign/detail/${campaignId}`);
  },

  async updateCampaign(recId: string, campaign: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPut(`campaign/${recId}`, campaign);
  },

  async deleteCampaign(recId: string): AxiosUtilsType {
    return await axiosPatch(`campaign/${recId}`);
  },
};
export default CampaignService;
